import { Box } from "@mui/material";
import React from "react";
import styles from "./emailComponent.module.scss";
import PropTypes from "prop-types";

const PreviewEmailComponent = (props) => {
  const { pdfUrl } = props;
  return (
    <Box className={styles.previewWrapper} data-testid="PreviewEmailComponent">
      <iframe
        src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=0`}
        title="PDF Preview"
        width="100%"
        height="600px"
        style={{ border: "none" }}
      ></iframe>
    </Box>
  );
};

export default PreviewEmailComponent;
PreviewEmailComponent.propTypes = {
  pdfUrl : PropTypes.any
}
